import { render, staticRenderFns } from "./VisualizacionOyentesArtistas.vue?vue&type=template&id=9b0d8b0c&scoped=true&"
import script from "./VisualizacionOyentesArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionOyentesArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionOyentesArtistas.vue?vue&type=style&index=0&id=9b0d8b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b0d8b0c",
  null
  
)

export default component.exports